import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const ModalNetInstallation = ({ show, onHide, onSkip, onAccept }) => {
  const isLogin = useSelector((state) => state.auth.status_login);
  const userid = useSelector((state) => state.auth.userid);
  const dataLogin = useSelector((state) => state.auth.data_login);
  const location = useLocation();
  const dispatch = useDispatch();
  const { status_login } = useSelector((state) => state.auth);
  const { paymentMethod } = useSelector((state) => state.cart);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingSkip, setLoadingSkip] = useState(false);
  const [message, setMessage] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  // Reset states when modal is shown/hidden
  useEffect(() => {
    if (!show) {
      setMessage("");
      setIsProcessing(false);
    }
  }, [show]);

  const handleAccept = async () => {
    if (loadingAccept || loadingSkip || isProcessing) return; // Prevent multiple clicks

    if (status_login === true && paymentMethod && location.pathname === "/ordersummary") {
      const clientData = dataLogin?.client;

      if (!clientData) {
        console.log("Client data not found");
        onAccept && onAccept(); // Continue with checkout even if client data is missing
        return;
      }

      const clientId = clientData.id;
      let clientPhone = clientData.phonenumber;
      const clientEmail = clientData.email;

      if (!clientId) {
        console.log("Client ID not found");
        onAccept && onAccept(); // Continue with checkout even if client ID is missing
        return;
      }

      if (!clientPhone) {
        clientPhone = "-";
      }

      const url = `${process.env.REACT_APP_BASE_API}order/apis/sendEmailForRelabs.php?&clientid=${clientId}&address1=${clientData.address1 || ''}&name=${clientData.firstname || ''}&phone=${clientPhone}&email=${clientEmail || ''}`;

      try {
        setLoadingAccept(true);
        setIsProcessing(true);

        // Reduced timeout to 10 seconds
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000);

        const response = await fetch(url, {
          method: 'POST',
          signal: controller.signal
        });

        clearTimeout(timeoutId);

        const result = await response.json();

        if (result.code === 200) {
          setMessage("Terima Kasih, Kami akan segera menginformasikan kembali kepada Anda melalui kontak email/telepon yang terdaftar.");
          // Update status in CheckoutTable
          window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
            detail: { status: 'Sudah Dikirim' }
          }));
          setTimeout(() => {
            onAccept && onAccept();
          }, 2000); // Reduced to 2 seconds
        } else {
          setMessage(result.data || result.message || "Maaf, terjadi kesalahan. Melanjutkan ke checkout...");
          setTimeout(() => {
            onAccept && onAccept(); // Continue with checkout even on error
          }, 2000);
        }
      } catch (error) {
        console.error("Error sending email:", error);
        setMessage("Melanjutkan ke proses checkout...");
        setTimeout(() => {
          onAccept && onAccept(); // Continue with checkout even on error
        }, 1500);
      } finally {
        setLoadingAccept(false);
        setIsProcessing(false);
      }
    } else {
      // If conditions not met, continue with checkout
      onAccept && onAccept();
    }
  };

  const handleSkip = async () => {
    if (loadingAccept || loadingSkip || isProcessing) return; // Prevent multiple clicks

    const clientEmail = dataLogin?.client?.email;

    if (!clientEmail) {
      console.log("Client email not found");
      onSkip && onSkip(); // Continue with checkout even if email is missing
      return;
    }

    try {
      setLoadingSkip(true);
      setIsProcessing(true);

      // Reduced timeout to 8 seconds
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 8000);

      const url = `${process.env.REACT_APP_BASE_API}order/apis/sendEmailForRelabs.php?action=skip&email=${encodeURIComponent(clientEmail)}`;
      const response = await fetch(url, {
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const result = await response.json();

      if (result.code === 200) {
        setMessage("Penawaran internet berhasil dilewati. Melanjutkan ke proses checkout...");
        // Update status in CheckoutTable
        window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
          detail: { status: 'Dilewati' }
        }));
        setTimeout(() => {
          onSkip && onSkip();
        }, 1000); // Reduced to 1 second
      } else {
        console.error("Error updating skip status:", result.data);
        setMessage("Melanjutkan ke proses checkout...");
        setTimeout(() => {
          onSkip && onSkip(); // Continue with checkout even on error
        }, 1000);
      }
    } catch (error) {
      console.error("Error skipping offer:", error);
      setMessage("Melanjutkan ke proses checkout...");
      setTimeout(() => {
        onSkip && onSkip(); // Continue with checkout even on error
      }, 1000);
    } finally {
      setLoadingSkip(false);
      setIsProcessing(false);
    }
  };

  const handleClose = () => {
    if (loadingAccept || loadingSkip || isProcessing) return; // Prevent closing during loading
    onHide && onHide();
  };

  const address1 = dataLogin?.client?.address1 || "Alamat Anda";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header 
        closeButton={!loadingAccept && !loadingSkip && !isProcessing}
        className="border-bottom pb-3"
      >
        <Modal.Title className="w-100 text-center fw-bold">Penawaran Khusus</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        {message ? (
          <div className="text-center">
            <p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.6" }}>{message}</p>
          </div>
        ) : (
          <div className="text-center">
            <p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.6" }}>
              <strong>Selamat!</strong> Alamat Anda yang berlokasi di <strong className="text-qw-primary">{address1}</strong> kemungkinan tersedia provider Qwords Internet. Apakah Anda tertarik untuk mendapatkan penawaran Qwords Internet?
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-top pt-3">
        {!message && (
          <div className="row w-100 g-3">
            <div className="col-lg-6 col-12">
              <button
                className={`btn btn-modal-outline-daftar-secondary w-100 ${(loadingAccept || loadingSkip || isProcessing) ? 'disabled' : ''}`}
                onClick={handleSkip}
                disabled={loadingAccept || loadingSkip || isProcessing}
                style={(loadingAccept || loadingSkip || isProcessing) ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
              >
                {loadingSkip ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Memproses...
                  </>
                ) : (
                  "Nanti Saja"
                )}
              </button>
            </div>
            <div className="col-lg-6 col-12">
              <button
                className={`btn btn-modal-confirmation w-100 ${(loadingAccept || loadingSkip || isProcessing) ? 'disabled' : ''}`}
                onClick={handleAccept}
                disabled={loadingAccept || loadingSkip || isProcessing}
                style={(loadingAccept || loadingSkip || isProcessing) ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
              >
                {loadingAccept ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Mengirim...
                  </>
                ) : (
                  "Ya, Saya Bersedia"
                )}
              </button>
            </div>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalNetInstallation;
